import ModalPortal from "../ModalPortal";

const ConfirmDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  message,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  isDeleting,
  busyLabel = "Borrando propiedad...",
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <ModalPortal>
      <div className="fixed inset-0 w-full h-full bg-black/50 flex justify-center items-center z-[70] px-4">
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-sm">
          {title && (
            <h3 className="text-base font-bold text-gray-800 dark:text-gray-100 mb-2">{title}</h3>
          )}
          <p className="text-sm text-gray-700 dark:text-gray-200">{message}</p>
          <div className="flex justify-end mt-5 gap-2">
            <button
              className="bg-gray-200 dark:bg-gray-600 hover:bg-gray-300 dark:hover:bg-gray-500 text-gray-700 dark:text-gray-200 font-medium py-2 px-4 rounded-lg disabled:opacity-50"
              onClick={onCancel}
              disabled={isDeleting}
            >
              {cancelLabel}
            </button>
            <button
              className="bg-red-500 hover:bg-red-600 text-white font-medium py-2 px-4 rounded-lg disabled:opacity-50"
              onClick={onConfirm}
              disabled={isDeleting}
            >
              {isDeleting ? busyLabel : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export default ConfirmDialog;
